import decode from 'jwt-decode';
import { getCookie, deleteCookie, setCookie } from './cookie'
export default class ApiService {
    constructor() {
        this.domain = '/api'
        this.fetch = this.fetch.bind(this)
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)

        this.actions = {

            'get.baseList': this.domain + '/base/list/?disciplineid/?languageid',
            'get.base': this.domain + '/base/?baseid',
            'get.question': this.domain + '/base/?baseid/question/?questionid',
            'get.file': this.domain + '/base/file/?baseid/?questionid/?filename',
            'get.disciplineList': this.domain + '/discipline/list',
            'get.undistributedSpecialty': this.domain + '/specialty/undistributed/?disciplineid/?languageid',
            'get.newgoogletoken': this.domain + '/auth/updategoogletoken',
            'get.generatedtickets': this.domain + '/generator/generate/?baseid/?count/?token',
            'get.searchUser': this.domain + '/user/search',
    
            'add.base': this.domain + '/base/createfor/?disciplineid/?languageid',
            'add.question': this.domain + '/base/?baseid/question',
            'add.specialty': this.domain + '/base/?baseid/specialty',
    
            'edit.baseName': this.domain + '/base/changename/?baseid',
            'edit.question': this.domain + '/base/?baseid/question/?questionid',
            'edit.count': this.domain + '/base/?baseid/setgencount/?questionid',
    
            'delete.base': this.domain + '/base/?baseid',
            'delete.question': this.domain + '/base/?baseid/question/?questionid',
            'delete.specialty': this.domain + '/base/?baseid/specialty/?specialtyid'
    
        }
    }

    



    login(username, password) {
        // Get a token
        return this.fetch(`${this.domain}/auth/signin`, {
            method: 'POST',
            body: JSON.stringify({
                login: username,
                pass: password
            })
        }).then(res => {
            this.setToken(res.token)
            this.setGoogleToken(res.googleToken)
            return Promise.resolve(res);
        })
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken()
        return !!token && !this.isTokenExpired(token) // handwaiving here
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) {
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }

    updateGoogleToken() {
        return this.fetch(`${this.domain}/auth/updategoogletoken`).then(res => {
            this.setGoogleToken(res)
            return Promise.resolve(res);
        })
    }

    isGoogleTokenExpired(googleToken) {
        if (!googleToken)
        {
            return true
        }
        return !(googleToken.expire <= Date.now() / 1000)
    }

    setGoogleToken(googleToken) {
        // localStorage.setItem('googleToken', JSON.stringify(googleToken))
        setCookie('googleToken', JSON.stringify(googleToken), { expires: new Date(googleToken.expire) })
    }

    async getGoogleToken() {

        let googleToken = getCookie('googleToken')

        if (!googleToken) {
            try {
                googleToken = await this.updateGoogleToken()
            } catch (error) {
                throw error
            }
        }
        if (this.isGoogleTokenExpired(googleToken)) {
            try {
                googleToken = await this.updateGoogleToken()
            } catch (error) {
                throw error
            }
        }

        return googleToken
    }

    // setToken(idToken) {
    //     // Saves user token to localStorage
    //     localStorage.setItem('id_token', idToken)
    // }

    getToken() {
        // Retrieves the user token from localStorage
    
        // return localStorage.getItem('id_token')
        return getCookie('id_token')
    }

    logout() {
        // Clear user token and profile data from localStorage
        //localStorage.removeItem('id_token');
        deleteCookie('id_token')
        deleteCookie('googleToken')
        // localStorage.removeItem('googleToken')
    }

    getProfile() {
        return decode(this.getToken());
    }


    call(action, parameters = {}, body = null, isFormData = false) {
        let url = this.actions[action]

        for (const key in parameters) {
            url = url.replace('?' + key, parameters[key])
        }

        let method = ''

        switch (action.split('.')[0]) {
            case 'get': method = 'GET'; break;
            case 'add': method = 'POST'; break;
            case 'edit': method = 'PUT'; break;
            case 'delete': method = 'DELETE'; break;
            
            default:
                break;
        }
        
        const b = body ? isFormData ? body : JSON.stringify(body) : null

        console.log('BODY', b)

        return this.fetch(url, {
            method,
            body: b
        }, isFormData).then(res => {
            return Promise.resolve(res);
        })

        // let func = () => { }
        // const order = body ? [body, options] : [options, null]

        // switch (action.split('.')[0]) {
        //     case 'get': func = axios.get; break;
        //     case 'add': func = axios.post; break;
        //     case 'edit': func = axios.put; break;
        //     case 'delete': func = axios.delete; break;
        //     default: break;
        // }
    }
    // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFbXBsb3llZUlEIjoxMTk5LCJMb2dpbiI6IkVLVFVcXElLb3RseWFyb3ZhIiwiTmFtZSI6ItCa0L7RgtC70Y_RgNC-0LLQsCDQmNGA0LjQvdCwINCQ0LvQtdC60YHQsNC90LTRgNC-0LLQvdCwIiwiQWNjZXNzTGV2ZWwiOjMsIkFsbG93ZWREaXNjaXBsaW5lcyI6IjY2OC0xLDc3My0xLDM1NjctMSw0NzIzLTEsNDcyNi0xLDEwNjQxLTEsMTMwMTYtMSwxMzAxNi0yLDE0MTE3LTEsMTU2NDAtMSIsImlhdCI6MTU3MzUzMjUyNywiZXhwIjoxNTczNTc1NzI3fQ.ejxNJHuEaBngzr7PPit99VsxPeCnno2dHsswvwqVPc8

    fetch(url, options, isFormData = false) {
        // performs api calls sending the required authentication headers
        let headers = {
            'Accept': '*/*',
            
        }
        if (!isFormData) {
            headers["Content-Type"] = 'application/json'
        }
        

        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }

        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus)
            .then(response => response.json())
    }

    _checkStatus(response) {
        // raises an error in case response status is not a success
        if (response.status >= 200 && response.status < 300) {
            return response
        } else {
            // var error = new Error(response)
            // error.response = response
            const r = response
            throw r
        }
    }
}